import React from 'react';

import { makeStyles } from '@material-ui/styles';
import { Fab } from '@material-ui/core';

const useStyles = makeStyles( (theme) => ({
  root: {
    ...theme.overrides.MuiButton.outlinedPrimary
  }
}))

// Custom styling for MUI Fab
export const OutlinedFab = (props) => {
  const classes = useStyles();
  return (
    <Fab {...props} className={classes.root + ' ' + props.className}>
      {props.children}
    </Fab>
  )
}

// OutlinedFab.muiName = Fab.muiName;